import { Badge, Card, CardContent, Tabs, TabsContent, TabsList, TabsTrigger } from '@werkstatt/ui';
import { MainLayout } from '../../components/MainLayout';
import { useAuthStore } from '../../store/authStore';
import { ProfileTab } from './ProfileTab';
import { SecurityTab } from './SecurityTab';
import { TwoFactorTab } from './TwoFactorTab';
import { SessionsTab } from './SessionsTab';

const ROLE_LABELS: Record<string, string> = {
  super_admin: 'Super-Administrator',
  admin: 'Administrator',
  user: 'Benutzer',
};

export default function Account() {
  const { user } = useAuthStore();

  return (
    <MainLayout>
      <div className="space-y-6">
        <div>
          <h1 className="font-display text-3xl font-bold tracking-tight">Konto</h1>
          <p className="text-muted-foreground mt-1">
            Profil, Passwort, aktive Sitzungen und Zwei-Faktor-Authentifizierung
          </p>
        </div>

        <Card variant="glass">
          <CardContent className="flex flex-wrap items-center gap-x-8 gap-y-2 p-6 text-sm">
            <div>
              <p className="text-muted-foreground">E-Mail</p>
              <p className="font-medium">{user?.email}</p>
            </div>
            <div>
              <p className="text-muted-foreground">Rolle</p>
              <Badge variant="outline">{ROLE_LABELS[user?.role ?? ''] ?? user?.role}</Badge>
            </div>
          </CardContent>
        </Card>

        <Tabs defaultValue="profile">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="profile">Profil</TabsTrigger>
            <TabsTrigger value="security">Sicherheit</TabsTrigger>
            <TabsTrigger value="2fa">2FA</TabsTrigger>
            <TabsTrigger value="sessions">Sitzungen</TabsTrigger>
          </TabsList>

          <TabsContent value="profile" className="mt-4">
            <ProfileTab />
          </TabsContent>
          <TabsContent value="security" className="mt-4">
            <SecurityTab />
          </TabsContent>
          <TabsContent value="2fa" className="mt-4">
            <TwoFactorTab />
          </TabsContent>
          <TabsContent value="sessions" className="mt-4">
            <SessionsTab />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
}
